
<div class="branch">

	<div class="folderLine">

		<div
			class="toggleCollapse"
			(click)="branch.folder.bCollapsed = !branch.folder.bCollapsed"
		>
			
			@if( branch.files.length || branch.subBranches.length ) {
				<span class="material-icons fIcon">
					{{ branch.folder.bCollapsed ? 'chevron_right' : 'expand_more' }}
				</span>
			}
			@else {
				<span class="material-icons fIcon">
					remove
				</span>
			}
	
			<span class="material-icons fIcon">
				folder
			</span>

			<span>{{branch.folder.fileName}}</span>

		</div>

		@if( bAdmin ) {

			<div class="folderButtons">
	
				<span
					class="material-icons fIcon iconBtn"
					(click)="clickCreateFolder()"
					title="Ordnererstellen"
				>
					create_new_folder
				</span>
	
				<span
					class="material-icons fIcon iconBtn"
					(click)="clickUpload()"
					title="Hochladen"
				>
					upload
				</span>
	
			</div>
			
		}

	</div>

	@if( !branch.folder.bCollapsed ) {

		<div [@detailExpand]>

			@if( branch.files.length ) {

				<div class="fileLines">

					@for( file of branch.files; track file.hash ) {
						<div
							(click)="download(file)"
							class="fileLine"
						>
							<span class="material-icons fIcon">description</span>
							<span class="fileLink">{{file.fileName}}</span>
						</div>
					}

				</div>

			}

			@if( branch.subBranches.length ) {
				@for( subBranch of branch.subBranches; track subBranch.folder.hash ) {
					<app-branch-display [branch]="subBranch" />
				}
			}

		</div>
	
	}

</div>